import { TimeSheetDayProjectTimeEntryFragment } from '../../../../__generated__/graphql';
import { TimeEntryItem } from './types';
import { TimeEntryProps } from '../../../Projects/types';
import { calculateDurationInMinutes, toMomentDateTime } from './index';
import { minutesToHours } from '../../../../../../utils/time';

export const calculateSavedProjectTimeEntriesByTimeEntryId = (
  projectTimeEntries:
    | ReadonlyArray<TimeSheetDayProjectTimeEntryFragment>
    | undefined,
): Record<string, number> => {
  if (!projectTimeEntries) {
    return {};
  }

  return projectTimeEntries.reduce<Record<string, number>>((acc, entry) => {
    const timeEntryId = entry.projectTimeEntry?.flair__Time_Entry__c;
    if (timeEntryId) {
      acc[timeEntryId] =
        (acc[timeEntryId] || 0) + (entry.flair__Minutes__c || 0);
    }
    return acc;
  }, {});
};

export const calculateTotalProjectTimeEntriesMinutes = (
  currentProjectTimeEntriesByTimeEntryId: Record<string, number>,
  savedProjectTimeEntriesByTimeEntryId: Record<string, number>,
): number => {
  let total = 0;
  const processedTimeEntryIds = new Set<string>();

  Object.entries(currentProjectTimeEntriesByTimeEntryId).forEach(
    ([timeEntryId, minutes]) => {
      total += minutes;
      processedTimeEntryIds.add(timeEntryId);
    },
  );

  Object.entries(savedProjectTimeEntriesByTimeEntryId).forEach(
    ([timeEntryId, minutes]) => {
      if (!processedTimeEntryIds.has(timeEntryId)) {
        total += minutes;
      }
    },
  );

  return total;
};

export const mapTimeEntriesToTimeEntryProps = (
  timeEntries: TimeEntryItem[],
): TimeEntryProps[] => {
  return timeEntries
    .filter((entry) => entry.timeEntryId !== null)
    .map((entry) => {
      const startDatetime = toMomentDateTime(entry.start).toDate();
      const endDatetime = entry.end
        ? toMomentDateTime(entry.end).toDate()
        : null;

      const totalPeriodInMinutes = calculateDurationInMinutes(entry);
      const totalPeriodInHours = minutesToHours(totalPeriodInMinutes);

      const totalBreakPeriodInMinutes = entry.breaks.reduce(
        (acc, breakItem) => acc + calculateDurationInMinutes(breakItem),
        0,
      );
      const totalBreakPeriodInHours = minutesToHours(totalBreakPeriodInMinutes);

      const workingPeriodInHours = totalPeriodInHours - totalBreakPeriodInHours;

      return {
        id: entry.timeEntryId!,
        startDatetime,
        endDatetime,
        totalBreakPeriodInHours,
        totalPeriodInHours,
        workingPeriodInHours,
        notes: entry.notes || null,
      };
    });
};
